export default class fullscreen {
    constructor(manager,scene) {

        //manager
        this.manager = manager;
        this.sceneManager = scene;

    }
    init(){
    }
    show(){

        TweenMax.set(this.sceneManager.$slideList , {
            css:{
                'z-index':0,
                'opacity': 0,
                'display':'none',
            }
        });
        TweenMax.set(this.sceneManager.$slideList , {
            rotation:0,
        });
        TweenMax.set(this.sceneManager.$slideList[this.sceneManager.status.current] , {
            css:{
                'z-index':1,
                'opacity': 1,
                'display':'block',
            }
        });

        //フルスクリーンモードということです
        this.sceneManager.status.mode = 'full';
        //スクロール禁止フラグ立てます
        this.manager.status.transFlg = true;

        if(this.manager.scroll.inertia){
            this.manager.scroll.nowInc = Math.round(this.manager.scroll.nowInc);
            this.manager.scroll.$body.style.transform = 'translateY(-'+ this.manager.scroll.nowInc +'px)'
        }

        this.resize();

        setTimeout(()=>{

            TweenMax.set(this.sceneManager.$slide,{
                scale:1.08,
                opacity:0,
            });
            TweenMax.set(this.sceneManager.$slide.querySelector('ul'),{
                rotation:1,
            });

            setTimeout(()=>{

                this.manager.color.set(
                    this.sceneManager.colorArray.logoColor[this.sceneManager.status.next],
                    this.sceneManager.colorArray.snsColor[this.sceneManager.status.next],
                    this.sceneManager.colorArray.footerColor[this.sceneManager.status.next],
                    this.sceneManager.colorArray.menuColor[this.sceneManager.status.next],
                    this.sceneManager.colorArray.headerOpacity[this.sceneManager.status.next]
                );

                // ------------ 左のスクロールを促すアイコンを消します
                this.manager.scrollIcon.hide();

                // ------------ リストを消します
                TweenMax.staggerTo(this.sceneManager.$coverList, (this.manager.param.displayType == 'sp')? 1.5:1.8 ,{
                    x:'95%',
                    ease:this.manager.ease
                },0.1);
                TweenMax.staggerTo(this.sceneManager.$coverList, (this.manager.param.displayType == 'sp')? .75:.9 ,{
                    skewX:-5,
                    ease:this.manager.ease
                },0.1);
                TweenMax.staggerTo(this.sceneManager.$coverList, (this.manager.param.displayType == 'sp')? .85:1.1 ,{
                    delay:(this.manager.param.displayType == 'sp')? .6:.7,
                    skewX:0,
                    ease:this.manager.ease
                },0.1,()=>{
                    TweenMax.set(this.sceneManager.$wrap ,{
                        display:'none'
                    });
                });
                // ------------ ページタイトルを消します
                TweenMax.to(this.sceneManager.$title, 1.2 , {
                    delay:1.2,
                    x: (this.manager.param.displayType == 'sp')? '-50px':'-100px',
                    opacity: 0,
                    ease:this.manager.ease,
                    onStart:() => {
                        // ------------ フルスクリーンを出します
                        TweenMax.to(this.sceneManager.$slide, 1.6 , {
                            delay: 1.0,
                            opacity: 1,
                            ease: Power2.easeOut,
                            onStart:() => {
                                this.controlShow();
                            },
                            onComplete:() => {
                                this.sceneManager.$slide.classList.add('is-open');
                                this.sceneManager.status.motion = false;
                            }
                        });
                        TweenMax.to(this.sceneManager.$slide.querySelector('ul'), 1.6 , {
                            delay: 1.0,
                            rotation: 0,
                            ease: Power2.easeOut
                        });
                        TweenMax.to(this.sceneManager.$slide, 2.2 , {
                            delay: 1.0,
                            scale:1,
                            ease: Power2.easeOut,
                        });
                        // ------------ spの時fixedフッターを表示
                        if(this.manager.param.displayType == 'sp'){
                            TweenMax.to('#l-footer_sp', .6 ,{
                                delay:0.6,
                                opacity:0,
                                ease: Power2.easeOut
                            });
                            TweenMax.to('#l-footer', .6 ,{
                                delay:0.6,
                                opacity:1,
                                ease: Power2.easeOut,
                            });
                        }
                    }
                });
            },1e2);
        },1e2);

    }

    hide(){

        this.controlHide();

        TweenMax.set(this.sceneManager.$wrap ,{
            display:'block'
        });

        TweenMax.to(this.sceneManager.$slide, 1.2 ,{
            delay:.3,
            opacity:0,
            ease:this.manager.ease,
            onStart: () => {

                // ------------ 左のスクロールを促すアイコンは非表示で動かしておく
                this.manager.scrollIcon.play();

                // ------------ spの時fixedフッターを非表示
                if(this.manager.param.displayType == 'sp'){
                    TweenMax.to('#l-footer', .6 ,{
                        opacity:0,
                        ease: Power2.easeOut,
                    });
                    TweenMax.to('#l-footer_sp', .6 ,{
                        opacity:1,
                        ease: Power2.easeOut,
                    });
                }

                // ------------ ページタイトル表示
                TweenMax.to(this.sceneManager.$title, 1.2 , {
                    x: '0',
                    opacity: 1,
                    ease:this.manager.ease,
                });
                TweenMax.staggerFromTo(this.sceneManager.$coverList, 1.6 ,{
                    x:'95%',
                    skewX:5,
                },{
                    x:'0%',
                    skewX: 0,
                    ease:this.manager.ease,
                    onStart: () => {
                        //フルスクリーンモードやめます！
                        this.sceneManager.status.mode = 'scroll';
                        //スクロール禁止フラグ折ります
                        this.manager.status.transFlg = false;
                        this.resize();
                        this.manager.scroll.inc = this.sceneManager.status.PosiY;
                        this.manager.scroll.nowInc = this.sceneManager.status.PosiY;
                        this.manager.scroll.prevInc = this.sceneManager.status.PosiY;
                        window.scrollTo(0,this.sceneManager.status.PosiY);
                        if(this.manager.scroll.nowInc > Number(this.manager.scroll.bodyHeight - window.innerHeight - 300) && this.manager.param.displayType == 'sp') {
                            TweenMax.set(this.manager.scroll.$scrollIcon, {
                                y: -50,
                                opacity: 0
                            });
                        }
                    },
                    onComplete:() => {
                        this.manager.color.set('black','black','black','black',1);
                        TweenMax.set(this.sceneManager.$slide,{
                            opacity:0,
                        });
                        this.sceneManager.$slide.classList.remove('is-open');
                        this.sceneManager.status.motion = false;
                        this.sceneManager.transition.set();
                    }
                },0.1);
            }
        });

    }

    controlShow(){
        TweenMax.staggerFromTo(this.sceneManager.$controlList, 1.2 , {
            x: '50px',
            display: 'none',
            opacity:0,
        },{
            x: '0',
            display:'block',
            opacity:1,
            ease:this.manager.ease,
        },0.03);
    }

    controlHide(){
        TweenMax.killTweensOf(this.sceneManager.$controlList);
        TweenMax.staggerTo(this.sceneManager.$controlList, 1.2 , {
            x: '50px',
            display: 'none',
            opacity:0,
            ease:this.manager.ease,
        },0.05);
    }

    render(mouse,scrollInc){

    }
    resize(){

        let _rect = this.sceneManager.$scrollList[this.sceneManager.status.current].getBoundingClientRect();
        // x offset
        this.sceneManager.status.absolutePosiX = _rect.left;
        // y offset
        this.sceneManager.status.absolutePosiY = _rect.top;
        this.sceneManager.status.PosiY = Math.round(_rect.top + this.manager.scroll.nowInc);

    }

}